import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: PetitionCommentsPagePaginatedDataContext,
	Provider: PetitionCommentsPagePaginatedDataContextProvider,
	useContext: usePetitionCommentsPagePaginatedData,
	useAsyncData: usePetitionCommentsPagePaginatedDataFromApi,
	prefetchAsyncData: prefetchPetitionCommentsPagePaginatedDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'PetitionCommentsPagePaginatedDataContext',
	dataProperty: 'pagePaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler(),
});
